export default __webpack_public_path__ + "assets/media/Bottom_Banner_MOB.fa61cad3.webp";